// src/hooks/useScrollSpy.js
import { useEffect, useState } from 'react';

/**
 * Παρακολουθεί ποιο section είναι στο viewport και επιστρέφει το ενεργό id.
 * Δούλεμα:
 * - Βάζουμε ids στα sections (π.χ. #about, #apps ...)
 * - Περνάμε τα ids στο hook
 * - Παίρνουμε πίσω activeId και τονίζουμε το αντίστοιχο link
 */
export default function useScrollSpy(
  sectionIds,
  { rootMargin = '-45% 0px -45% 0px', threshold = 0.01 } = {}
) {
  const [activeId, setActiveId] = useState(sectionIds[0] || '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) setActiveId(visible.target.id);
      },
      { root: null, rootMargin, threshold }
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [sectionIds, rootMargin, threshold]);

  return activeId;
}
